import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Button, Form, Icon } from 'semantic-ui-react';
import MessageList from './MessageList';

class SnukForm extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    tReady: PropTypes.bool.isRequired,
    schema: PropTypes.shape({}).isRequired,
    initValues: PropTypes.shape({}),
    shape: PropTypes.shape({}).isRequired,
    onSubmitAction: PropTypes.func.isRequired,
    onCancelAction: PropTypes.func,
    isPending: PropTypes.bool.isRequired,
    externalMessage: PropTypes.shape({
      messages: PropTypes.arrayOf(PropTypes.string).isRequired,
      isError: PropTypes.bool.isRequired,
    }),
    btnText: PropTypes.string.isRequired,
    itemId: PropTypes.string,
    iconName: PropTypes.string,
    btnStyle: PropTypes.string,
    leftElement: PropTypes.func,
    leftElementOnClick: PropTypes.func,
  };

  static defaultProps = {
    initValues: {},
    externalMessage: {
      messages: [],
      isError: false,
    },
    iconName: null,
    btnStyle: null,
    onCancelAction: null,
    leftElement: null,
    leftElementOnClick: null,
    itemId: null,
  };

  constructor(props) {
    super(props);
    const { shape, initValues } = this.props;
    const state = {};
    state.isError = false;
    state.messages = [];
    state.values = {};
    Array.from(shape).forEach(([key, info]) => {
      if (!info.disabled) {
        state.values[key] = initValues[key] || '';
      }
    });
    this.state = { ...state };
    this.updateFieldValue = this.updateFieldValue.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  updateFieldValue(e, { value, field }) {
    this.setState(prevState => ({
      values: {
        ...prevState.values,
        [field]: value,
      },
    }));
  }

  validateFields(data) {
    const {
      t, schema, onSubmitAction, itemId,
    } = this.props;
    const errors = [];

    Object.keys(data).forEach((field) => {
      const value = data[field];
      const { required, validate } = schema[field];
      if (required && validate && !validate.validator(value)) {
        errors.push(t(validate.message));
      }
    });

    if (errors.length) {
      this.setState({ messages: errors, isError: true });
    } else {
      this.setState({ messages: [], isError: false });
      onSubmitAction(itemId, data);
    }
  }

  customValidate(field, action) {
    const { t, schema } = this.props;
    const errors = [];
    const value = this.state.values[field];
    if (!schema[field].validate.validator(value)) {
      errors.push(t(schema[field].validate.message));
    }
    if (errors.length) {
      this.setState({ messages: errors, isError: true });
    } else {
      action(value);
    }
  }

  render() {
    const { isError, messages } = this.state;
    const {
      t, tReady, initValues, externalMessage, schema, shape, onSubmitAction, onCancelAction, isPending,
      btnText, iconName, btnStyle, leftElement: LeftElement, leftElementOnClick, itemId,
      ...rest
    } = this.props;
    const hasError = externalMessage.messages.length ? externalMessage.isError : isError;
    const text = externalMessage.messages.length ? externalMessage.messages : messages;
    return (
      <div>
        <MessageList isError={hasError} messages={text} />
        <Form {...rest}>
          <Fragment>
            {Array.from(shape).map(([key, shapeInfo]) => {
              const info = {
                ...shapeInfo,
                label: t(shapeInfo.label),
                placeholder: t(shapeInfo.placeholder),
              };
              const {
                width, kind, type = 'text', options, label, placeholder, disabled,
              } = info;

              if (disabled) {
                return <Fragment key={key} />;
              }

              const inputProps = {
                key,
                field: key,
                width,
                label,
                placeholder,
                disabled,
                onChange: this.updateFieldValue,
              };

              const value = this.state.values[key];

              switch (kind) {
                case 'textArea':
                  return (
                    <Form.TextArea
                      {...inputProps}
                      {...info}
                      type={type}
                    />
                  );
                case 'select': {
                  return (
                    <Form.Select
                      {...inputProps}
                      options={options}
                      value={value}
                    />
                  );
                }
                default: // 'input'
                  return (
                    <Form.Input
                      {...inputProps}
                      {...info}
                      type={type}
                      value={value}
                    />
                  );
              }
            })}
            {onCancelAction && <Button onClick={onCancelAction}>Cancel</Button>}
            {LeftElement && (
              <div onClick={() => leftElementOnClick(this)}>
                <LeftElement />
              </div>
            )}
            <Button
              icon
              positive={!btnStyle}
              loading={isPending}
              labelPosition={iconName && 'left'}
              floated="right"
              onClick={() => this.validateFields(this.state.values)}
            >
              {iconName && <Icon name="add" />}
              {btnText}
            </Button>
          </Fragment>
        </Form>
      </div>
    );
  }
}

export default translate()(SnukForm);



// WEBPACK FOOTER //
// ./src/components/reusable/SnukForm.js